'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product change description (optional including price)
 */
    .directive('capProductChangeDescription', function () {
        return {
            restrict: 'A',
            scope: {
                productName: "=",
                productLogoResourcePath: "=",
                productLogoResourceAlt: "=",
                productDescription: "="
            },
            templateUrl: "templates/productchangedescription.html"
        }
    });